const easingFunctions = {
    linear: t => t,

    inSine: t => 1 - Math.cos((t * Math.PI) / 2),
    outSine: t => Math.sin((t * Math.PI) / 2),
    inOutSine: t => -(Math.cos(Math.PI * t) - 1) / 2,

    inQuad: t => t * t,
    outQuad: t => 1 - (1 - t) * (1 - t),
    inOutQuad: t => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2),

    inCubic: t => t * t * t,
    outCubic: t => 1 - Math.pow(1 - t, 3),
    inOutCubic: t => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2),

    inQuart: t => t * t * t * t,
    outQuart: t => 1 - Math.pow(1 - t, 4),
    inOutQuart: t => (t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2),

    inQuint: t => t * t * t * t * t,
    outQuint: t => 1 - Math.pow(1 - t, 5),
    inOutQuint: t => (t < 0.5 ? 16 * t * t * t * t * t : 1 - Math.pow(-2 * t + 2, 5) / 2),

    inExpo: t => (t === 0 ? 0 : Math.pow(2, 10 * t - 10)),
    outExpo: t => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
    inOutExpo: t => {
        if (t === 0) return 0;
        if (t === 1) return 1;
        return t < 0.5 ? Math.pow(2, 20 * t - 10) / 2 : (2 - Math.pow(2, -20 * t + 10)) / 2;
    },

    inCirc: t => 1 - Math.sqrt(1 - t * t),
    outCirc: t => Math.sqrt(1 - (t -= 1) * t),
    inOutCirc: t =>
        t < 0.5 ? (1 - Math.sqrt(1 - 2 * t * (2 * t))) / 2 : (Math.sqrt(1 - (-2 * t + 2) * (-2 * t + 2)) + 1) / 2,

    // 其他可选：inBounce、outBounce、inBack、outBack等...
};

export default easingFunctions;
